<script lang="ts">
  import { cn } from "@/lib/utils";
  import { onMount } from 'svelte';

  export let className: string = '';

  const P_BOTTOM = 20; // px

  let myDiv;
  let topPx = 0;
  let positionCss: 'relative' | 'sticky' = 'relative'
  let scrollPosition: 'top' | 'bottom' | 'middle' = 'middle';

  let lastScrollY = typeof window !== 'undefined' ? window.scrollY : 0;
  let scrollDirection: 'up' | 'down' = 'down';

  function updatePosition(_event?: Event) {
    const currentY = window.scrollY;
    if (currentY !== lastScrollY) {
      scrollDirection = currentY > lastScrollY ? 'down' : 'up';
      lastScrollY = currentY;
    }

    if (myDiv) {
      const rect = myDiv.getBoundingClientRect();
      if (rect.height + 120 + P_BOTTOM < window.innerHeight) {
        // Element is smaller than viewport minus offsets; has to be sticky
        positionCss = 'sticky';
        topPx = 120;
        scrollPosition = 'top';
        return;
      }
      if (scrollPosition !== 'bottom' && rect.bottom < window.innerHeight - P_BOTTOM && scrollDirection === 'down') {
        positionCss = 'sticky';
        topPx = window.innerHeight - rect.height - P_BOTTOM;
        scrollPosition = 'bottom';
        return;
      } else if (scrollPosition !== 'top' && rect.top > 120 && scrollDirection === 'up') {
        positionCss = 'sticky';
        topPx = 120;
        scrollPosition = 'top';
        return;
      } else if (scrollPosition === 'top' && scrollDirection === 'down') {
        positionCss = 'relative';
        topPx = window.scrollY;
        scrollPosition = 'middle';
        return;
      } else if (scrollPosition === 'bottom' && scrollDirection === 'up') {
        positionCss = 'relative';
        topPx = window.scrollY + rect.top - 120;
        scrollPosition = 'middle';
        return;
      }
    }
  }

  function onHeightChange() {
    if (myDiv) {
      const rect = myDiv.getBoundingClientRect();
      if (rect.bottom < window.innerHeight - P_BOTTOM) {
        positionCss = 'sticky';
        topPx = window.innerHeight - rect.height - P_BOTTOM;
        scrollPosition = 'bottom';
      } else if (rect.top > 120) {
        positionCss = 'sticky';
        topPx = 120;
        scrollPosition = 'top';
      } else {
        positionCss = 'relative';
        topPx = window.scrollY + rect.top - 120;
        scrollPosition = 'middle';
      }
    }
  }

  function resetPosition() {
    positionCss = 'sticky';
    topPx = 120;
    scrollPosition = 'top';
  }

  // Update position on mount and on scroll/resize events
  onMount(() => {
    window.addEventListener('scroll', updatePosition);
    window.addEventListener('resize', resetPosition);
    return () => {
      window.removeEventListener('scroll', updatePosition);
      window.removeEventListener('resize', resetPosition);
    };
  });

  let containerSize: ResizeObserverSize[] | null = null;
  let containerHeight: number | null = null;
  $: if (containerSize && containerSize[0]) containerHeight = containerSize[0].blockSize;
  $: containerHeight, onHeightChange();

</script>

<div bind:borderBoxSize={containerSize} class={cn('h-max', className)} style={`position: ${positionCss}; top: ${topPx}px;`} bind:this={myDiv}>
  <slot/>
</div>
